import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class CarrierConfigurationsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(
        `${API_BASE_URL}/contract-service/carrier-configurations`,
        params
      ),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/contract-service/carrier-configurations/${id}`,
      requestOptions
    );
  }

  create(carrierConfigurations) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(carrierConfigurations),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/contract-service/carrier-configurations`,
      requestOptions
    );
  }

  edit(carrierConfigurations) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(carrierConfigurations),
    };
    return this.httpProxy.fetch(
      API_BASE_URL +
        `/contract-service/carrier-configurations/${carrierConfigurations.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/contract-service/carrier-configurations/${id}`,
      requestOptions
    );
  }
}
